var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { isSupportedBrowser } from "../../helpers";
import values from "lodash/values";
import { NotificationList } from "../Notification/NotificationsList";
// const mapStateToProps = (state) => {
//     return {
//         loaderState: get(state, "loaderReducer")
//     }
// }
// const mergeProps = ({ loaderState }) => {
//     return {
//         hasErrored: new LoaderState(loaderState).hasErrored()
//     }
// }
export var BrowserNotSupported = function (props) {
    var t = useTranslation().t;
    var hasErrored = props.hasErrored;
    var fallbackErrorMessage = props.fallbackErrorMessage;
    var initialNotifications = {};
    var _a = useState(initialNotifications), flashNotifications = _a[0], setFlashNotifications = _a[1];
    var browserSupport = useMemo(isSupportedBrowser, []);
    useEffect(function () {
        if (browserSupport)
            return;
        setFlashNotifications(__assign(__assign({}, flashNotifications), { browserSupport: {
                message: t('browser_not_supported'),
                level: "warning",
                canClose: false
            } }));
    }, [browserSupport]);
    useEffect(function () {
        if (!hasErrored)
            return;
        setFlashNotifications(__assign(__assign({}, flashNotifications), { apiError: {
                message: fallbackErrorMessage,
                level: "danger",
                canClose: false
            } }));
    }, [hasErrored, fallbackErrorMessage]);
    var notifications = useMemo(function () { return values(flashNotifications); }, [flashNotifications]);
    if (notifications.length === 0)
        return null;
    return (React.createElement(NotificationList, { items: notifications, className: props.className }));
};
